import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  Select,
  format_date,
  GET,
  PUT,
  t,
  can,
} from "../../components/CustomComponent.js";
import {
  EMPTY_GROUP,
  SHORTCUT_ICONS,
  TRANSIT_COLORS,
  ADMIN_ICON,
  clone,
  ordered,
  moveItem,
  nextSort,
  newUid,
} from "../../components/homepage_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/property_type.css";
import "../../assets/css/home_manage.css";
import "../../assets/css/homepage.css";

/* ============================================================================
 * จัดการหน้าแรก › ทางลัดค้นหา  (/ad/home/shortcuts)
 *
 * รวมทางลัด 3 ชุดที่วางคนละจุดในหน้าแรก แต่เป็นข้อมูลชนิดเดียวกัน
 * (ไอคอน + ป้ายชื่อ + ปลายทางค้นหา) จึงจัดการในหน้าเดียวแล้วสลับด้วยแท็บ
 *   1. หมวดหมู่ยอดนิยม  — แถวไอคอนกลมใต้กล่องค้นหา
 *   2. ค้นหาตามไลฟ์สไตล์ — กล่องขวาของแถวโครงการ
 *   3. แนวรถไฟฟ้า       — แถบเลื่อนใต้แถวโครงการ (มีสีประจำสายเพิ่มมา)
 * กล่องพรีวิวใช้ CSS ชุดเดียวกับหน้าเว็บจริง (.hm-cats / .hm-lifes / .hm-line)
 *
 * ข้อมูลอ่าน/บันทึกผ่าน API จริง
 *   GET  admin/homepage/shortcut
 *   PUT  admin/homepage/shortcut   (ส่ง { categories, lifestyles, transit })
 * บันทึกแบบแทนที่ทั้งชุด — จัดลำดับ/เปิด-ปิดในหน้าจอจนพอใจแล้วค่อยกดบันทึกครั้งเดียว
 * ========================================================================== */

/* แท็บละหนึ่งชุดข้อมูล — เก็บ meta ไว้ที่เดียว จะได้ไม่ต้องเขียน if ซ้ำทั้งไฟล์
   has_section = ชุดนั้นมีหัวข้อของส่วนให้แก้ไหม (หมวดหมู่ไม่มีหัวข้อบนหน้าเว็บ)
   has_color   = ชุดนั้นมีสีประจำรายการไหม (มีเฉพาะแนวรถไฟฟ้า) */
const TABS = [
  { key: "categories", label: "home_shortcut_tab_category", unit: "home_unit_shortcut", has_section: false, has_color: false, prefix: "cat" },
  { key: "lifestyles", label: "home_shortcut_tab_lifestyle", unit: "home_unit_shortcut", has_section: true, has_color: false, prefix: "lf" },
  { key: "transit", label: "home_shortcut_tab_transit", unit: "home_unit_line", has_section: true, has_color: true, prefix: "tr" },
];

const EMPTY_FORM = {
  icon: SHORTCUT_ICONS[0],
  label: "",
  sub: "",
  target: "",
  color: TRANSIT_COLORS[0].value,
  is_active: true,
};

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

export default class HomeShortcutSetting extends Component {
  constructor(props) {
    super(props);
    const data = clone(EMPTY_GROUP.shortcut);
    this.state = {
      tab: "categories",
      categories: data.categories,
      lifestyles: data.lifestyles,
      transit: data.transit,
      saved: clone(data),

      asset_tags: [], // แท็กที่มีทรัพย์ติดอยู่จริง [{ value, total }] ใช้เลือกปลายทางของปุ่ม

      modal_form: false,
      edit_uid: "",
      form: { ...EMPTY_FORM },
      updated_at: "",
      updated_by: "",
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
    this.GetTags();
  }

  /* โหลดเนื้อหากลุ่มนี้จากฐานข้อมูล — เรียกทั้งตอนเปิดหน้าและหลังบันทึกสำเร็จ
     เพื่อให้ uid ของรายการที่เพิ่งสร้างตรงกับฝั่ง server */
  Get = async () => {
    loading(true);
    const result = await GET("admin/homepage/shortcut", {});
    loading(false);
    if (result?.status && result.data) this.Apply(result.data);
  };

  /* แท็กที่ติดอยู่บนประกาศที่เผยแพร่แล้ว — ปุ่มทางลัด (โดยเฉพาะแนวรถไฟฟ้า) กรองทรัพย์
     ด้วยแท็ก ผู้ดูแลจึงต้องเลือกจากแท็กที่มีทรัพย์อยู่จริง ไม่ใช่พิมพ์เดาเอาเอง
     โหลดแยกจากเนื้อหาหน้าแรก เพราะเป็นข้อมูลของฝั่งทรัพย์ ไม่ได้เปลี่ยนตอนกดบันทึก
     ไม่ต้องกัน loading ซ้อน — เป็นข้อมูลเสริมของฟอร์ม ไม่มีก็แค่ไม่มีชิปให้กด */
  GetTags = async () => {
    const result = await GET("admin/assets/tags", {});
    if (result?.status && Array.isArray(result.data)) this.setState({ asset_tags: result.data });
  };

  Apply = (data) =>
    this.setState({
      categories: data.categories || [],
      lifestyles: data.lifestyles,
      transit: data.transit,
      saved: clone({ categories: data.categories || [], lifestyles: data.lifestyles, transit: data.transit }),
      updated_at: data.updated_at || "",
      updated_by: data.updated_by || "",
    });

  current = () => ({
    categories: this.state.categories,
    lifestyles: this.state.lifestyles,
    transit: this.state.transit,
  });

  isDirty = () => JSON.stringify(this.current()) !== JSON.stringify(this.state.saved);

  meta = () => TABS.find((tab) => tab.key === this.state.tab);

  /* หมวดหมู่เก็บเป็น array เปล่า ๆ ส่วนอีก 2 ชุดมี { section, items } ครอบอยู่
     ตัวช่วยคู่นี้ทำให้โค้ดส่วนที่เหลืออ่าน/เขียน "รายการ" ได้แบบเดียวกันหมด */
  items = () => (this.state.tab === "categories" ? this.state.categories : this.state[this.state.tab].items);

  setItems = (updater) =>
    this.setState((prev) => {
      const key = prev.tab;
      const list = key === "categories" ? prev.categories : prev[key].items;
      const next = updater(list);
      return key === "categories" ? { categories: next } : { [key]: { ...prev[key], items: next } };
    });

  setSection = (patch) =>
    this.setState((prev) => ({ [prev.tab]: { ...prev[prev.tab], section: { ...prev[prev.tab].section, ...patch } } }));

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* ---------------------------------------------------- เปิดฟอร์ม เพิ่ม/แก้ */
  OpenCreate = () => this.setState({ modal_form: true, edit_uid: "", form: { ...EMPTY_FORM } });

  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      edit_uid: item.uid,
      form: {
        icon: item.icon || SHORTCUT_ICONS[0],
        /* แนวรถไฟฟ้าเก็บชื่อไว้ที่ name ส่วนอีก 2 ชุดเก็บที่ label — ฟอร์มใช้ช่องเดียวกัน */
        label: item.label || item.name || "",
        sub: item.sub || "",
        target: item.target || "",
        color: item.color || TRANSIT_COLORS[0].value,
        is_active: !!item.is_active,
      },
    });

  CloseForm = () => this.setState({ modal_form: false });

  SaveItem = () => {
    const { form, edit_uid, tab } = this.state;
    const meta = this.meta();
    if (!form.label.trim()) return alert("", "warning", t("warning"), t("home_verify_shortcut_label"));

    const payload = { icon: form.icon, target: form.target.trim(), is_active: form.is_active };
    if (tab === "transit") {
      payload.name = form.label.trim();
      payload.sub = form.sub.trim();
      payload.color = form.color;
    } else {
      payload.label = form.label.trim();
    }

    this.setItems((list) =>
      edit_uid
        ? list.map((row) => (row.uid === edit_uid ? { ...row, ...payload } : row))
        : [...list, { ...payload, uid: newUid(meta.prefix), sort: nextSort(list) }],
    );
    this.setState({ modal_form: false });
  };

  Move = (item, step) => this.setItems((list) => moveItem(list, item.uid, step));

  ToggleActive = (item) =>
    this.setItems((list) => list.map((row) => (row.uid === item.uid ? { ...row, is_active: !row.is_active } : row)));

  Delete = async (item) => {
    const name = item.label || item.name;
    if (!(await alert("", "warning", t("delete_item"), `${t("home_delete_shortcut_desc")}\n${name}`, t("confirm"), t("cancel")))) return;
    this.setItems((list) => list.filter((row) => row.uid !== item.uid));
  };

  Save = async () => {
    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT("admin/homepage/shortcut", this.current());
    loading(false);
    if (!result?.status) return;

    this.Apply(result.data);
    alert("", "success", t("success"), t("home_save_done"));
  };

  Reset = async () => {
    if (!this.isDirty()) return;
    if (!(await alert("", "warning", t("reset_changes"), t("discard_changes_confirm"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ ...clone(prev.saved) }));
  };

  /* ====================================================== render : ตัวจัดการ */
  renderList = () => {
    const { tab } = this.state;
    const meta = this.meta();
    const list = ordered(this.items());
    const active = list.filter((item) => item.is_active).length;
    const dirty = this.isDirty();
    const section = meta.has_section ? this.state[tab].section : null;

    return (
      <div className="prop-card prop-in">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_shortcut_list_title")}
          </span>
          <div className="hmg-sum">
            <span className="ppl-pill ppl-pill--ghost">
              {list.length} {t(meta.unit)}
            </span>
            <span className="ppl-pill ppl-pill--on">
              <span className="ppl-pill__dot" />
              {active} {t("active")}
            </span>
            {can("homepage.update") && (
              <button type="button" className="prop-btn prop-btn--ghost" onClick={this.OpenCreate}>
                <span className="icon text-12">{ADMIN_ICON.plus}</span>
                {t("home_add_shortcut")}
              </button>
            )}
          </div>
        </div>

        {/* เลือกชุดที่จะจัดการ */}
        <div className="p-4 pb-2">
          <label className="prop-label">{t("home_shortcut_group")}</label>
          <div className="prop-seg">
            {TABS.map((item) => (
              <button
                key={item.key}
                type="button"
                aria-pressed={tab === item.key}
                className={`prop-seg__btn ${tab === item.key ? "is-active" : ""}`}
                onClick={() => this.setState({ tab: item.key })}
              >
                {t(item.label)}
              </button>
            ))}
          </div>
          <div className="ppl-sub mt-2">{t(`home_shortcut_hint_${tab}`)}</div>

          {section && (
            <div className="mt-3">
              <label className="prop-label">
                {t("home_section_title")} <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="prop-field"
                maxLength={40}
                value={section.title}
                onChange={(e) => this.setSection({ title: e.target.value })}
              />
            </div>
          )}
        </div>

        <div className="hmg-list">
          {list.map((item, index) => (
            <div className={`hmg-row ${item.is_active ? "" : "is-off"}`} key={item.uid}>
              <div className="d-flex align-items-center gap-2">
                <span className="pty-rank">{index + 1}</span>
                <div className="pty-order">
                  <button type="button" className="pty-order__btn icon" title={t("ptype_move_up")} disabled={index === 0} onClick={() => this.Move(item, -1)}>
                    {ADMIN_ICON.up}
                  </button>
                  <button
                    type="button"
                    className="pty-order__btn icon"
                    title={t("ptype_move_down")}
                    disabled={index === list.length - 1}
                    onClick={() => this.Move(item, 1)}
                  >
                    {ADMIN_ICON.down}
                  </button>
                </div>
              </div>

              <div
                className="hmg-icon icon"
                style={meta.has_color ? { background: item.color, color: "#fff", borderColor: "transparent" } : undefined}
              >
                {item.icon}
              </div>

              <div className="hmg-row__body">
                <div className="hmg-row__title">
                  <span>{item.label || item.name}</span>
                </div>
                <div className="hmg-row__desc">
                  {item.sub ? `${item.sub} · ` : ""}
                  {item.target || t("home_shortcut_no_target")}
                  {/* ปลายทางชี้ไปยังแท็กที่ยังไม่มีทรัพย์ติดอยู่ = กดแล้วได้หน้าว่าง */}
                  {!!this.missingTags(item.target).length && (
                    <span className="text-danger fw-bold"> · {t("home_shortcut_tag_missing")}</span>
                  )}
                </div>
              </div>

              {/* เปิด/ปิด แก้ไข ลบ : ต้องมีสิทธิ์แก้ไขหน้าแรก */}
              {can("homepage.update") && (
                <div className="hmg-row__actions">
                  <label className="ppl-switch" title={item.is_active ? t("home_hide") : t("home_show")}>
                    <input type="checkbox" checked={item.is_active} onChange={() => this.ToggleActive(item)} />
                    <span className="ppl-switch__track" />
                  </label>
                  <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} onClick={() => this.OpenEdit(item)}>
                    {ADMIN_ICON.edit}
                  </button>
                  <button
                    type="button"
                    className="prop-iconbtn icon"
                    style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                    title={t("delete")}
                    onClick={() => this.Delete(item)}
                  >
                    {ADMIN_ICON.trash}
                  </button>
                </div>
              )}
            </div>
          ))}

          {!list.length && (
            <div className="hmg-empty">
              <span className="icon">{ADMIN_ICON.grid}</span>
              {t("home_empty_shortcut")}
            </div>
          )}
        </div>

        {/* ไม่มีสิทธิ์แก้ = ไม่ต้องมีแถบบันทึก ดูอย่างเดียว */}
        {can("homepage.update") && (
          <div className="ppl-savebar">
            {dirty ? (
              <span className="ppl-dirty">
                <span className="ppl-dirty__dot" />
                {t("unsaved_changes")}
              </span>
            ) : (
              <span className="text-secondary text-12 d-flex align-items-center gap-2">
                <span className="icon">{ADMIN_ICON.check}</span>
                {t("all_changes_saved")}
              </span>
            )}
            <div className="d-flex gap-2">
              <button type="button" className="prop-btn prop-btn--ghost" disabled={!dirty} onClick={this.Reset}>
                <span className="icon text-12">{ADMIN_ICON.reset}</span>
                {t("reset_changes")}
              </button>
              <button type="button" className="prop-btn" disabled={!dirty} onClick={this.Save}>
                <span className="icon text-12">{ADMIN_ICON.save}</span>
                {t("save_settings")}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  /* ==================================================== render : กล่องพรีวิว */
  /* วาดด้วยคลาสจริงของหน้าเว็บ ผู้ดูแลจะได้เห็นผลตรงกับที่ลูกค้าเห็นทุกจุด */
  previewBody = () => {
    const { tab } = this.state;
    const list = ordered(this.items()).filter((item) => item.is_active);

    if (!list.length) return <div className="hmg-empty">{t("home_empty_shortcut")}</div>;

    if (tab === "categories") {
      return (
        <div className="hm-cats" style={{ marginTop: 0 }}>
          {list.map((item) => (
            <span key={item.uid} className="hm-cat">
              <span className="hm-cat__icon hm-ico" style={{ width: "42px", height: "42px", fontSize: "16px" }}>
                {item.icon}
              </span>
              <span className="hm-cat__label" style={{ fontSize: "11px" }}>
                {item.label}
              </span>
            </span>
          ))}
        </div>
      );
    }

    if (tab === "lifestyles") {
      return (
        <>
          <div className="hm-section__title hm-section__title--sm" style={{ fontSize: "15px", marginBottom: "10px" }}>
            {this.state.lifestyles.section.title}
          </div>
          <div className="hm-lifes" style={{ gap: "8px" }}>
            {list.map((item) => (
              <span key={item.uid} className="hm-life" style={{ minHeight: "74px", fontSize: "11px" }}>
                <span className="hm-life__icon hm-ico" style={{ fontSize: "16px" }}>
                  {item.icon}
                </span>
                <span className="hm-life__label">{item.label}</span>
              </span>
            ))}
          </div>
        </>
      );
    }

    return (
      <>
        <div className="hm-section__title hm-section__title--sm" style={{ fontSize: "15px", marginBottom: "10px" }}>
          {this.state.transit.section.title}
        </div>
        <div className="d-flex flex-column gap-2">
          {list.map((item) => (
            <span key={item.uid} className="hm-line" style={{ padding: "9px 11px" }}>
              <span className="hm-line__logo hm-ico" style={{ background: item.color, width: "30px", height: "30px", fontSize: "13px" }}>
                {item.icon}
              </span>
              <span className="hm-line__body">
                <span className="hm-line__name" style={{ fontSize: "13px" }}>
                  {item.name}
                </span>
                <span className="hm-line__sub" style={{ fontSize: "11px" }}>
                  {item.sub}
                </span>
              </span>
              <span className="hm-line__more" style={{ fontSize: "11px" }}>
                {t("view_all")}
              </span>
            </span>
          ))}
        </div>
      </>
    );
  };

  renderPreview = () => (
    <div className="prop-card prop-in hmg-preview">
      <div className="prop-card__head">
        <span className="prop-title text-14">
          <span className="prop-title__dot" />
          {t("home_preview")}
        </span>
        <a className="prop-link" href="/" target="_blank" rel="noreferrer">
          <span className="icon text-12">{ADMIN_ICON.external}</span>
          {t("home_open_site")}
        </a>
      </div>

      <div className="p-3">
        <div className="hmg-frame">
          <div className="hmg-frame__bar">
            <span className="hmg-frame__dot" />
            <span className="hmg-frame__dot" />
            <span className="hmg-frame__dot" />
            <span className="hmg-frame__url">safespacelifeliving.com</span>
          </div>
          <div className="hmg-frame__body" style={{ background: "#ffffff" }}>
            <div className="mn-home">{this.previewBody()}</div>
          </div>
        </div>

        <div className="ppl-note mt-3">
          <span className="icon">{ADMIN_ICON.info}</span>
          <div>{t("home_shortcut_preview_hint")}</div>
        </div>
      </div>
    </div>
  );

  /* ------------------------------------------------ ปลายทางแบบแท็กของทรัพย์ */
  /* ปลายทางที่ไม่ใช่ประเภททรัพย์ (type= / types= / pet=) ถือเป็น "แท็ก" ทั้งหมด
     รวมถึง line= ของแนวรถไฟฟ้า — หน้าเว็บลูกค้าตีความแบบเดียวกันที่
     page/homepage/options.js › shortcutParams ถ้าจะแก้ ต้องแก้ให้ตรงกันทั้งสองที่ */
  targetTags = (value) => {
    const target = String(value || "").trim();
    if (!target) return [];

    const at = target.indexOf("=");
    const key = at === -1 ? "tag" : target.slice(0, at).trim();
    if (["type", "types", "pet"].includes(key)) return [];

    return (at === -1 ? target : target.slice(at + 1))
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);
  };

  /* แท็กในปลายทางที่ยังไม่มีทรัพย์ติดอยู่เลย — กดปุ่มนี้ในหน้าเว็บแล้วจะได้หน้าว่าง
     บอกไว้ตั้งแต่ในรายการ ผู้ดูแลจะได้ไม่ต้องไปเจอเองตอนลูกค้าเจอไปแล้ว
     ยังโหลดแท็กไม่เสร็จ (หรือเรียกไม่ผ่าน) = ไม่ทัก จะได้ไม่ทักผิด */
  missingTags = (target) => {
    const { asset_tags } = this.state;
    if (!asset_tags.length) return [];
    return this.targetTags(target).filter((tag) => !asset_tags.some((row) => row.value === tag));
  };

  /* กดชิป = เพิ่ม/เอาออกจากรายการแท็กของปลายทาง (ติดแท็กใดแท็กหนึ่งก็เข้าเงื่อนไข)
     เขียนกลับเป็น tag=... เสมอ ผู้ดูแลจึงเห็นค่าที่จะถูกบันทึกจริงในช่องด้านบน */
  toggleTag = (value) => {
    const tags = this.targetTags(this.state.form.target);
    const next = tags.includes(value) ? tags.filter((tag) => tag !== value) : [...tags, value];
    this.setForm({ target: next.length ? `tag=${next.join(",")}` : "" });
  };

  renderTagPicker = () => {
    const { asset_tags } = this.state;
    if (!asset_tags.length) return null;

    const selected = this.targetTags(this.state.form.target);

    return (
      <div className="col-12">
        <label className="prop-label">{t("home_shortcut_target_tags")}</label>
        <div className="hmg-picker hmg-picker--tag">
          {asset_tags.map((tag) => (
            <button
              key={tag.value}
              type="button"
              className={`hmg-picker__tag ${selected.includes(tag.value) ? "is-on" : ""}`}
              onClick={() => this.toggleTag(tag.value)}
            >
              {tag.value}
              <small>{tag.total}</small>
            </button>
          ))}
        </div>
        <div className="ppl-sub mt-1">{t("home_shortcut_target_tags_hint")}</div>
      </div>
    );
  };

  /* ================================================== render : ฟอร์มเพิ่ม/แก้ */
  renderFormModal = () => {
    const { modal_form, edit_uid, form } = this.state;
    const meta = this.meta();

    return (
      <Modal show={modal_form} onHide={this.CloseForm} size="lg" centered>
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("home_edit_shortcut") : t("home_add_shortcut")}</h5>
            <div className="text-secondary text-12">{t("home_shortcut_form_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          {/* ตัวอย่างของจริง */}
          <div className="mn-home mb-4 d-flex justify-content-center">
            {meta.has_color ? (
              <span className="hm-line" style={{ minWidth: "220px" }}>
                <span className="hm-line__logo hm-ico" style={{ background: form.color }}>
                  {form.icon}
                </span>
                <span className="hm-line__body">
                  <span className="hm-line__name">{form.label || t("home_shortcut_placeholder")}</span>
                  <span className="hm-line__sub">{form.sub}</span>
                </span>
              </span>
            ) : (
              <span className="hm-cat" style={{ flex: "0 0 auto" }}>
                <span className="hm-cat__icon hm-ico">{form.icon}</span>
                <span className="hm-cat__label">{form.label || t("home_shortcut_placeholder")}</span>
              </span>
            )}
          </div>

          <div className="row g-3">
            <div className={meta.has_color ? "col-md-4" : "col-md-8"}>
              <label className="prop-label">
                {t("home_shortcut_label")} <span className="text-danger">*</span>
              </label>
              <input type="text" className="prop-field" maxLength={26} value={form.label} onChange={(e) => this.setForm({ label: e.target.value })} />
            </div>

            {meta.has_color && (
              <>
                <div className="col-md-4">
                  <label className="prop-label">{t("home_shortcut_sub")}</label>
                  <input type="text" className="prop-field" maxLength={26} value={form.sub} onChange={(e) => this.setForm({ sub: e.target.value })} />
                </div>
                <div className="col-md-4">
                  <label className="prop-label">{t("home_shortcut_color")}</label>
                  <Select
                    default={false}
                    value={form.color}
                    options={TRANSIT_COLORS.map((color) => ({ value: color.value, label: t(color.label) }))}
                    onChange={(value) => value && this.setForm({ color: value })}
                  />
                </div>
              </>
            )}

            <div className="col-md-4">
              <label className="prop-label">{t("status")}</label>
              <div className="d-flex align-items-center gap-2" style={{ height: "44px" }}>
                <label className="ppl-switch">
                  <input type="checkbox" checked={form.is_active} onChange={(e) => this.setForm({ is_active: e.target.checked })} />
                  <span className="ppl-switch__track" />
                </label>
                <span className={`text-12 fw-bold ${form.is_active ? "text-success" : "text-secondary"}`}>
                  {form.is_active ? t("home_show") : t("home_hide")}
                </span>
              </div>
            </div>

            <div className={meta.has_color ? "col-md-8" : "col-12"}>
              <label className="prop-label">{t("home_shortcut_target")}</label>
              <input
                type="text"
                className="prop-field"
                maxLength={120}
                placeholder={meta.has_color ? "tag=near_bts" : "type=condo"}
                value={form.target}
                onChange={(e) => this.setForm({ target: e.target.value })}
              />
              <div className="ppl-sub mt-1">{t("home_shortcut_target_hint")}</div>
            </div>

            {this.renderTagPicker()}

            <div className="col-12">
              <label className="prop-label">{t("home_shortcut_icon")}</label>
              <div className="hmg-picker">
                {SHORTCUT_ICONS.map((icon) => (
                  <button key={icon} type="button" className={`hmg-picker__icon icon ${form.icon === icon ? "is-on" : ""}`} onClick={() => this.setForm({ icon })}>
                    {icon}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseForm}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.SaveItem}>
            <span className="icon text-12">{ADMIN_ICON.check}</span>
            {t("confirm")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { updated_at, updated_by } = this.state;

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("home_shortcut_manage")}</h3>
              <div className="text-secondary text-14">{t("home_shortcut_manage_desc")}</div>
            </div>
            <div className="text-secondary text-12 text-lg-end">
              <div>
                {t("updated")} {format_date(updated_at, "dd mmm yyyy hh:mm", locale())}
              </div>
              <div>
                {t("updated_by")} {updated_by}
              </div>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-xl-7 col-lg-7">{this.renderList()}</div>
            <div className="col-xl-5 col-lg-5">{this.renderPreview()}</div>
          </div>
        </div>

        {this.renderFormModal()}
      </div>
    );
  }
}
